// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8908) return "static/chunks/8908.6efebf130384f3e7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"488":"8cc59a4c3fff87fc","1334":"01c9e19fe49f0c4f","6323":"63e24dc8d3408ff2"}[chunkId] + ".js";
};